module.exports = __webpack_public_path__ + "img/givenchy_gentleman.047613ab.jpg";